import { useFlags } from "../use-flags.js";
import { Fragment, jsx } from "react/jsx-runtime";

//#region src/client/components/FlaggedComponent.tsx
function FlaggedComponent({ check, children, fallback = null, flag, value }) {
	const { [flag]: flagValue } = useFlags();
	if (typeof check === "function") return check(flagValue) ? /* @__PURE__ */ jsx(Fragment, { children }) : fallback;
	if (typeof value === "undefined") return flagValue ? /* @__PURE__ */ jsx(Fragment, { children }) : fallback;
	return flagValue === value ? /* @__PURE__ */ jsx(Fragment, { children }) : fallback;
}

//#endregion
export { FlaggedComponent };